import { putPromise } from "./request-promise";

export function addUpdateUtilizationGoals(utilizationGoalParams) {
    return putPromise(
        '/api/dashboards/highchart_analytics/create_update_drilling_goal',
        utilizationGoalParams,
        (data) => data || null
    );
}
